import React from 'react'
import Link, { withPrefix } from 'gatsby-link'
import Helmet from 'react-helmet'
import 'babel-polyfill'

//  Components
import HomeIntro from '../components/HomeIntro/HomeIntro.js'
import PageHeader from '../components/PageHeader/PageHeader.js'
import ThemeLink from '../components/ThemeLink/ThemeLink.js'
import KeyThemes from '../components/KeyThemes/KeyThemes.js'
import Button from '../components/Button/Button.js'
import Downloads from '../components/Downloads/Downloads.js'
import TopBottom from '../components/Visualizations/containers/top-bottom'

const IndexPage = ({data}) => (
  <div>
    <HomeIntro data={ data } />
    <div className="section section__full section__pull_top section__exhibit section__exhibit__padded">
      <h2 className="title__block">The Top &amp; Bottom</h2>
      <TopBottom />
      <div className="section__centered">
        <Button
          to="/rankings"
          text="Check Out All States"
          />
      </div>
    </div>
    <div className="section">
      <div className="section__row section__row__2_up">
        <div className="section__content section__content__narrow">
          <h3>We use recently available data to assess every state and Washington, DC on more than 40 measures of health care access, quality, efficiency, health outcomes and disparities.</h3>
        </div>
        <div className="section__content section__content__wide">
          <p>Hawaii, Massachusetts, Minnesota, Washington, Connecticut, and Vermont are the top-ranked states in 2019 according to the <em>Scorecard</em>, which assesses all 50 states and the District of Columbia on 47 measures of access to health care, quality of care, service use and costs of care, health outcomes, and income-based health care disparities.</p>
          <p>The Commonwealth Fund’s <em>2019 Scorecard on State Health System Performance</em> reveals that most states are losing ground on key measures related to life expectancy as premature deaths from suicide, alcohol, and drug overdose continue to increase. Several states that most recently expanded eligibility for their Medicaid programs saw meaningful gains in access to health care; in other states prior gains eroded between 2016 and 2017. Finally, the <em>Scorecard</em> found that health care costs are placing an increasing financial burden on families across the nation.</p>
        </div>
      </div>
    </div>
    <KeyThemes data={ data } />
    <Downloads />
  </div>
)

export default IndexPage

export const query = graphql`
  query SiteQuery {
    site {
      pathPrefix
      siteMetadata {
        title
        year
        subtitle
      }
    }
    allThemesJson {
      edges {
        node {
          theme_id
          title
          path
          stat {
            suffix
            number
            text
          }
        }
      }
    }
    allStatesJson {
      edges {
        node {
          id
          title
          url
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js